import Parse from 'parse';

const WL_WEB_KEY   = "X-WL-Web-Key";

var wlWebKey = process.env[WL_WEB_KEY]

if (typeof(wlWebKey) == "undefined"){

    wlWebKey = "TEST-123"
}

const HEADER_VALUE = "TEST-123";

module.exports = {

    // fetchParseConfig() {
    //     Parse.Config.get()
    //         .then(
    //             (config) => {
    //                 console.log(`Config was fetched from the server. ${config}`);
    //             },
    //             (error) => {
    //                 console.log(`Failed to fetch. Using Cached Config. ${error}`);
    //             }
    //         );
    // },

    sendAjaxRequestDeferred(URL, dataToSend) {

        const defer = $.Deferred();
        this.sendAjaxRequest(URL, dataToSend)
            .complete((data) => {
                defer.resolve(data);
            });
        return defer.promise();
    },

    sendAjaxRequest(URL, dataToSend) {

      return $.ajax({
            type        : 'POST',
            url         : URL,
            crossDomain : true,
            headers     : { [WL_WEB_KEY]: wlWebKey },
            data        : JSON.stringify(dataToSend),
            dataType    : 'json'
        }).fail(function(responseData) {
            if ( responseData.responseCode ) {
                console.log( responseData.responseCode );
            }
        });
    },

    getLocationDetail(locId, userId, userSession) {
        const URL     = `${CLOUD_URL}LocationDetail`;

        const dataToSend = {
            functionName : "getLocationDetail",
            userId       : userId,
            userSession: userSession,
            params: {
                objectId: locId,
                sendPvtData: true
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    getOrderStatsAt(userId, sessionToken, dateRange, locId) {
        const URL = CLOUD_URL + "OrderStats";

        let dataToSend = {
            functionName: "getOrderStatsAt",
            userId: userId,
            userSession: sessionToken,
            params: {
                locId: locId,
                dateRange   : dateRange,
             }
        };
        return this.sendAjaxRequest(URL, dataToSend);
    },

    getOrderStats(userId, sessionToken, generationDate, locId) {
        const URL = CLOUD_URL+"OrderStats";

        let dataToSend = {
            functionName : "getOrderStats",
            userId       : userId,
            userSession  : sessionToken,
            params       : { generationDate, locId  }
        };
        return this.sendAjaxRequestDeferred(URL, dataToSend);
    },

    getUserStatsForLocId(userId, sessionToken, locId, limit, bizId, skip, count = true) {
        const URL = CLOUD_URL+"UserStats";

        let dataToSend = {
            functionName : "getAllUserStats",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                bizId       : bizId,
                locId       : locId,
                skip        : skip,
                limit       : limit,
                count       : count
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    // Hide this function
    getLocationsForBizId(bizId) {
        const URL = CLOUD_URL+"LocationDetail";

        let dataToSend = {
            functionName : "getLocationsForBizId",
            params       : { bizId }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    isAccountConnected(userId, sessionToken, locId) {
        const URL = CLOUD_URL+"LocationDetail";

        let dataToSend = {
            functionName : "isAccountConnected",
            userId       : userId,
            userSession  : sessionToken,
            params       : { locId }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    fetchBillingDetails(userId, sessionToken, bizId) {
        const URL = CLOUD_URL+"BusinessDetail";

        let dataToSend = {
            functionName : "fetchBillingDetails",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                bizId
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    createLocationDetail(userId, userSession, params) {
        const URL = CLOUD_URL+"LocationDetail";

        let dataToSend = {
            functionName : "createLocationDetail",
            userId, userSession, params
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    orderMarkLocationActivation(userId, userSession, params){

        const URL = CLOUD_URL+"OrderMark";

        let dataToSend = {
            functionName : "locationActivation",
            userId       : userId,
            userSession  : userSession,
            params       : params
        };

        return this.sendAjaxRequest(URL, dataToSend);

    },

    updateLocation(userId, userSession, bizId, locId, params){

        const URL = CLOUD_URL+"LocationDetail";

        let dataToSend = {
            functionName : "updateLocationDetail",
            userId       : userId,
            userSession  : userSession,
            bizId        : bizId,
            locId        : locId,
            params       : params
        };

        return this.sendAjaxRequest(URL, dataToSend);

    },


    createBusinessDetail(userId, userSession, params) {
        const URL = CLOUD_URL+"BusinessDetail";

        let dataToSend = {
            functionName : "createBusinessDetail",
            userId, userSession, params
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    updateBusinessDetail(userId, userSession, params) {
        const URL = CLOUD_URL+"BusinessDetail";

        let dataToSend = {
            functionName : "updateBusinessDetail",
            userId, userSession, params
        };

        return this.sendAjaxRequest(URL,dataToSend);
    },

    getBusinessDetail(bizId) {
        const URL = CLOUD_URL+"BusinessDetail";

        const params = { bizId };

        let dataToSend = {
            functionName : "getBusinessDetail",
            params
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    saveCustomerTempData(userId, locId) {
        let dataToSend = {
            userId , locId
        };

        return $.ajax({
            type        : 'POST',
            url         : '/api/saveUser',
            data        : dataToSend,
            dataType    : 'json'
        }).fail(function(responseData) {
            if ( responseData.responseCode ){
                console.log( responseData.responseCode );
            }
        });
    },

    acceptNewLead(data) {
        let URL = CLOUD_URL+"Marketing";

        let dataToSend = {
            functionName : "acceptNewLead",
            params       : data
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    getPastOrders(sessionToken, locId, userId, limit) {
        let URL = CLOUD_URL+"Order";

        let dataToSend = {
            functionName : "getPastOrders",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                locId  : locId,
                userId : userId,
            }
        };

        if(limit){
             dataToSend.params["limit"]=limit;
        }

        return this.sendAjaxRequest(URL,dataToSend);
    },

    getOrdersAt(userId, sessionToken, dateRange, locId, limit, bizId, skip, count = true) {
        const URL = `${CLOUD_URL}Order`;

        const dataToSend = {
            functionName : "getOrdersAt",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                bizId       : bizId,
                locId       : locId,
                dateRange   : dateRange,
                skip        : skip,
                limit       : limit,
                count       : count
            }
        };

        // if (limit) {
        //     dataToSend.params["limit"] = limit;
        // }

        return this.sendAjaxRequest(URL, dataToSend);
    },

    getOrdersSummary(userId, sessionToken, dateRange, locId, bizId) {
        const URL = `${CLOUD_URL}Order`;

        const dataToSend = {
            functionName : "getOrdersSummary",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                bizId       : bizId,
                locId       : locId,
                dateRange   : dateRange
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    getChargeSummary(userId, sessionToken, params) {
        const URL = `${CLOUD_URL}Order`;

        const dataToSend = {
            functionName : "getChargeSummary",
            userId       : userId,
            userSession  : sessionToken,
            params       : params
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    // Stripe related api methods
    findCustomerData(userId, sessionToken, customerId, isBankInfoNeeded = false) {
        let URL = CLOUD_URL+"UserAccount";

        let dataToSend = {
            functionName : "findCustomerData",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                customerId : customerId,
                bankInfo   : isBankInfoNeeded
            }
        };

        return this.sendAjaxRequest(URL,dataToSend);
    },

    createCustomerOnStripe(userId, sessionToken, customerId, customerDetails, token) {
        let URL = CLOUD_URL+"UserAccount";

        let dataToSend = {
            functionName : "createCustomer",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                userId          : userId,
                customerId      : customerId,
                customerDetails : customerDetails,
                token           : token
            }
        };

        return this.sendAjaxRequest(URL,dataToSend);
    },

    createOrUpdateCustomerOnStripe(locId, userId, sessionToken, customerId, customerDetails, token) {
        let URL = CLOUD_URL+"UserAccount";

        let dataToSend = {
            functionName : "createOrUpdateCustomer",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                locId           : locId,
                userId          : userId,
                customerId      : customerId,
                customerDetails : customerDetails,
                token           : token
            }
        };

        return this.sendAjaxRequest(URL,dataToSend);
    },

    createBankCustomerOnStripe(locId, userId, sessionToken, customerId, customerDetails, token) {
        let URL = CLOUD_URL+"UserAccount";

        let dataToSend = {
            functionName : "createOrUpdateBankCustomer",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                locId           : locId,
                userId          : userId,
                customerId      : customerId,
                customerDetails : customerDetails,
                token           : token
            }
        };

        return this.sendAjaxRequest(URL,dataToSend);
    },

    deletePaymentMethod(userId, sessionToken, customerId, token) {
        let URL = CLOUD_URL+"UserAccount";

        let dataToSend = {
            functionName : "deletePaymentMethod",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                customerId      : customerId,
                token           : token
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    acceptPayment(userId, sessionToken, paymentObject) {
        let URL = CLOUD_URL+"Order";

        let dataToSend = {
            functionName : "acceptPayment",
            userId       : userId,
            userSession  : sessionToken,
            params       : paymentObject
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    requestEmailVerification(userId, sessionToken, ) {
        let URL         = CLOUD_URL+"UserAccount";
        const loc       = window.location;
        let redirectUrl = loc.protocol + "//"+loc.host

        let dataToSend  = {
            functionName : "sendVerificationEmail",
            userId       : userId,
            userSession  : sessionToken,
            params       : {
                userId : userId,
                domain : redirectUrl
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);

    },
    getAllLocations() {

        let currentUser = Parse.User.current();
        const businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;

        const URL = `${CLOUD_URL}BusinessDetail`;
        const dataToSend = {
            functionName : "getAllLocations",
            params       : {
                bizId : bizId,
                sendDineInLocation:true
            }
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },
    // SK : Change Here
    getGroupDetails(bizId, includePointer, locId = null) {
        // console.log("biz here group " + bizId);
        const URL = `${CLOUD_URL}GroupDetail`;
        const dataToSend = {
            functionName : "getGroupDetails",
            params       : {
                bizId
            }
        };
        if (locId) {
            dataToSend.params["locId"] = locId;
        }

        if (includePointer) {
            dataToSend.params["pointers"] = ["bizId"];
        }

        // console.log(dataToSend);

        return this.sendAjaxRequest(URL, dataToSend);
    },
    // SK- Change Here
    getItemDetails(bizId, includePointer, locId = null) {

        //  console.log("biz here " + bizId);

        const URL = `${CLOUD_URL}ItemDetail`;
        const dataToSend = {
            functionName : "getItemDetails",
            params       : {
                bizId
            }
        };

        if (locId) {
            dataToSend.params["locId"] = locId;
        }

        if (includePointer) {
            dataToSend.params["pointers"] = ["bizId", "groupDetailPointer"];
        }

        //   console.log(dataToSend);

        return this.sendAjaxRequest(URL, dataToSend);
    },

    //MARK: /ItemDetail
    // Create and Update item for location
    updateItemDetail(isNew, userId, userSession, bizId, params) {
        const URL = `${CLOUD_URL}ItemDetail`;

        const dataToSend = {
            functionName : isNew ? "createItemDetail" : "updateItemDetail",
            userId       : userId,
            userSession  : userSession,
            bizId        : bizId,
            params       : params
        };

        return this.sendAjaxRequest(URL, dataToSend);
    },

    deleteItemDetail(userId, userSession, bizId, params){
        const URL = `${CLOUD_URL}ItemDetail`;

        const dataToSend = {
            functionName : "deleteItemDetail",
            userId       : userId,
            userSession  : userSession,
            bizId        : bizId,
            params       : params
        };

        return this.sendAjaxRequest(URL, dataToSend);


    },

    getAllDataViaRest(activeLocationIndex, activeLocationId) {

        const data = {};
        const grpIdGrpDetailMap = {};
        const self = this;

        return this.getAllLocations()
            .then(
                (responseData) => {
                    if (responseData.data) {
                        const locDetails = responseData.data.BusinessLocations;
                        data.BusinessLocations = responseData.data.BusinessLocations;
                        data.BusinessDetail = responseData.data.BusinessDetail;

                        if (activeLocationId != null){
                            // based on the active location ID(ObjectId) set the active location

                            const locationDetail = locDetails.filter(function (location) {
                                return location.objectId == activeLocationId;
                                // return location.objectId == '9lE5hysZGP';
                            });

                            // if location Object Id match then return the Location object otherwise return the first array
                            if (locationDetail.length > 0){
                                data.LocationDetail = locationDetail[0];
                            }
                            else {
                                data.LocationDetail = locDetails[0];
                            }

                        }
                        else if (activeLocationIndex != null) {
                            // based on the active location index set the active location

                            const locationDetail = locDetails[activeLocationIndex];

                            data.LocationDetail = locationDetail;
                        } else {
                            // default set the first location as a active location
                            data.LocationDetail = locDetails[0];
                        }
                    }
                    return data;
                },
                // error case
                (errorResponseData) => {
                    console.log("Error while fetching business locations !");
                    if (errorResponseData && errorResponseData.responseJSON) {
                        console.log(errorResponseData.responseJSON.error.message);
                    }
                }
            )
            .then(
                (reData) => {
                    const businessDetail = reData.BusinessDetail;
                    const bizId = businessDetail.objectId;

                    // console.log("getGroupDetails: ------");

                    // check if the isMenuSameForAllLocation is false or not
                    if (businessDetail && businessDetail.bizConfig && businessDetail.bizConfig.isMenuSameForAllLocation == true) {
                        return self.getGroupDetails(bizId, false);
                    } else {
                        const locationDetail = reData.LocationDetail;
                        const locId = locationDetail.objectId;
                        return self.getGroupDetails(bizId, false,locId);
                    }
                })
            .then(
                (responseData) => {
                    if (responseData.data) {
                        const groupDetails = responseData.data;
                        groupDetails.forEach((groupDetail) => {
                            grpIdGrpDetailMap[groupDetail.objectId] = groupDetail;
                            groupDetail.bizId = Object.assign({}, groupDetail.bizId, data.BusinessDetail);
                        });
                        data.GroupDetails = groupDetails;
                    }
                    return data;
                },
                (errorResponseData) => {
                    console.log("Error while fetching group details !");
                    if (errorResponseData && errorResponseData.responseJSON) {
                        console.log(errorResponseData.responseJSON.error.message);
                    }
                })
            .then(
                (reData) => {
                    const businessDetail = reData.BusinessDetail;
                    const bizId = businessDetail.objectId;

                    //  console.log("getItemDetails: ------");

                    // check if the isMenuSameForAllLocation is false or not
                    if (businessDetail && businessDetail.bizConfig && businessDetail.bizConfig.isMenuSameForAllLocation == true) {

                        return self.getItemDetails(bizId, false);
                    } else {
                        const locationDetail = reData.LocationDetail;
                        const locId = locationDetail.objectId;
                        return self.getItemDetails(bizId, false, locId);
                    }
                })
            .then(
                (responseData) => {
                    // console.log(responseData.data);
                    if (responseData.data) {
                        let itemDetails = responseData.data;
                        itemDetails.forEach((itemDetail) => {
                            itemDetail.bizId = Object.assign({}, itemDetail.bizId, data.BusinessDetail);
                            itemDetail.groupDetailPointer = Object.assign({}, itemDetail.groupDetailPointer, grpIdGrpDetailMap[itemDetail.groupDetailPointer.objectId]);
                        });
                        data.ItemDetails = itemDetails;
                    }
                    return data;
                },
                (errorResponseData) => {
                    console.log("Error while fetching Item details !");
                    if (errorResponseData && errorResponseData.responseJSON) {
                        console.log(errorResponseData.responseJSON.error.message);
                    }
                })
            .then((tData) => tData);
    }

};



// WEBPACK FOOTER //
// src/Utils/api.js